export default "__VITE_ASSET__DD1ew$4F__"